<core-notifications-handler></core-notifications-handler>
<layout-default>
    <router-outlet></router-outlet>
    <iw-shop-news-modal #nm></iw-shop-news-modal>
    <!-- MODAL CHOOSE CUSTOMER -->
    <div *ngIf="!(selectedCustomer$ | async) && (userMappedCustomers$ | async) && (userMappedCustomers$ | async)?.length !== 0"
          class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Kunden auswählen</p>
            </header>
            <section class="modal-card-body">
                <nav class="panel">
                    <a class="panel-block" *ngFor="let item of (userMappedCustomers$ | async)"
                       (click)="selectCustomer(item.id || '')">
                        <span>
                            <b>Kd.-Nr.: {{ item.customerNumber }}</b><br>
                            <ng-container *ngFor="let address of item.addresses">
                              <ng-container *ngIf="address.type == 'billing' || address.type == undefined">
                                 {{ address.gesoftName1 }}, {{ address.gesoftName2 }}<br>
                                  {{ address.street }}<br>
                                  {{ address.postcode }}, {{ address.town }}<br>
                              </ng-container>
                            </ng-container>
                        </span>
                    </a>
                </nav>
            </section>
        </div>
    </div>
</layout-default>


